<template>
  <button :disabled="disabled || isLoading" :class="[{'disabled': disabled, 'loading': isLoading}, buttonClasses]" @click="$emit('click', $event)">
    <yz-spinner v-if="isLoading" :size="spinnerSize" :is-loading="true" />
    <slot v-if="!isLoading"></slot>
    {{ text }}
  </button>
</template>

<script>
  export default {
    props: {
      defaultText: String,
      disabledText: String,
      loadingText: {
        type: String,
        default () {
          return this.$t('loading')
        }
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      classes: {
        type: Array,
        default: () => ['btn', 'loading-btn']
      },
      spinnerSize: {
        type: String,
        default: '20px'
      },
      spinnerColor: {
        type: String,
        default: '#242424'
      }
    },

    computed: {
      buttonClasses () {
        if (this.classes == null) {
          return null
        }

        return this.classes
      },
      text () {
        return this.isLoading
          ? this.loadingText
          : this.disabled
            ? this.disabledText || this.defaultText
            : this.defaultText
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LoadingButton.vue?3f8584da